import formApplicant from './components/formApplicant'
import Api from '@api/api'
import { uuid } from '@/utils'
export default {
  components: { formApplicant },
  data () {
    return {
      fullscreenLoading: false, // loading加载
      // 步骤条
      stepList: [
        {
          name: '申请人信息'
        },
        {
          name: '被申请人信息'
        },
        {
          name: '行政复议请求'
        },
        {
          name: '事实和理由'
        },
        {
          name: '材料上传'
        }
      ],
      // 申请人信息
      applicantInfoList: [],
      applicantInfo: {
        applicantCategory: '1', // 1 个人 2法人
        applicantName: '',
        gender: '', // 0 女 1 男
        country: '',
        identificationType: '',
        identificationCard: '',
        identificationFile: '', // 证件材料路径
        bornDate: '', // 出生日期
        phone: '',
        telephone: '', // 座机
        addr: '',
        postcode: '',
        deliveryAddr: '', // 送达地址
        deliveryPostcode: '', // 送达地址邮编
        fileListJpg: [],
        isbornDate: false // 证件类型为身份证时 出生日期不可修改
      },
      legalpersonInfo: {
        applicantCategory: '2',
        applicantName: '',
        legalRepresentative: '',
        legalRepresentativeDuty: '',
        country: '',
        identificationType: '',
        identificationCard: '',
        identificationFile: '',
        bornDate: '',
        phone: '',
        telephone: '',
        addr: '',
        postcode: '',
        deliveryAddr: '',
        deliveryPostcode: '',
        fileListJpg: [],
        isbornDate: false // 证件类型为身份证时 出生日期不可修改
      },
      respondentInfos: {},
      // 被申请人信息
      respondentInfo: [],
      optionDepartId: [],
      // 被申请人名称
      optionRespondentName: [],
      // 行政复议请求
      applyInfo: {
        actCategory: '1', // 1不服行政不作为 2不服具体行政行为
        applyType: '',
        specificActType: '1' // 1请求撤销具体行政行为 2请求确认具体行政行为违法
      },
      // 事实和理由
      factAndReason: '',
      // 证据材料
      fileList1: [],
      fileoneLoad: false,
      fileList2: [],
      filetwoLoad: false,
      rest1: 0,
      rest2: 0,
      respondentInfoRules: {
        departId: [
          { required: true, message: '请选择复议机关', trigger: 'change' }
        ],
        respondentName: [
          { required: true, message: '请选择被申请人', trigger: 'change' }
        ]
      },
      // 必填信息
      inquireInfo: {
        caseOrderNo: '',
        inquirePwd: '12345678',
        reconsiderationAgency: '',
        inquirePhone: ''
      },
      // 申请编号
      number: '',
      uploadFileUrl: '',
      password: '',
      isDetail: false,
      caseOrderNo: '',
      evidenceIdList: []
    }
  },
  created () {
    // 获取复议机关
    Api.getAgency().then((res) => {
      this.optionDepartId = res.data.data
    })
    // 如果有编号 补正进入修改申请，否则新建申请
    this.number = this.$route.query.number ? this.$route.query.number : ''
    // 详情
    if (this.number) {
      this.getCaseInfoDetail()
      this.caseOrderNo = uuid()
      this.isDetail = true
    } else {
      // 新建
      this.inquireInfo.caseOrderNo = uuid()
      this.caseOrderNo = this.inquireInfo.caseOrderNo
      this.isDetail = false
    }
    console.log(this.isDetail, 'isDetail')
  },
  mounted () {
    this.inquireInfo.inquirePwd = this.$cookie.get('LoginPass')
    this.inquireInfo.inquirePhone = this.$cookie.get('LoginPhone')
    if (
      typeof this.inquireInfo.inquirePwd === 'undefined' &&
      typeof this.inquireInfo.inquirePhone === 'undefined'
    ) {
      this.$router.push('/codeSearch')
    }
  },
  methods: {
    // 复议机关
    ChangeReconsiderationAgency (v) {
      console.log('复议机关', v)
      this.respondentInfo = []
      this.getEntrustingDepartList(v.id)
    },
    // 获取被申请人名称
    getEntrustingDepartList (p) {
      Api.getEntrustingDepartList(p).then((res) => {
        this.optionRespondentName = res.data.data
      })
    },
    // 详情
    getCaseInfoDetail () {
      if (this.$cookie.get('LoginPass')) {
        this.password = this.$cookie.get('LoginPass')
      }
      const p = {
        number: this.number, // 查询编码
        password: this.password
      }
      Api.oldDetail(p).then((res) => {
        if (res.data.code === '0') {
          const data = res.data.data
          data.applicantInfo.forEach((item) => {
            if (item.identificationType === '1001001') {
              item.isbornDate = true
            } else {
              item.isbornDate = false
            }
            item.fileListJpg = []
            item.fileListJpg.push({
              name: item.originName,
              evidenceIdNo: item.evidenceId,
              id: item.id
            })
          })
          this.applicantInfoList = data.applicantInfo
          this.applyInfo = data.applyInfo
          // 被申请人信息
          data.respondentInfo.forEach((ite) => {
            ite.id = ite.departId
            ite.name = ite.respondentName
          })
          this.respondentInfo = data.respondentInfo
          this.factAndReason = data.factAndReasons
          // 复议机关
          data.inquireInfo.reconsiderationAgency = {
            name: data.inquireInfo.reconsiderationAgencyName,
            id: data.inquireInfo.reconsiderationAgency
          }
          // console.log(data.inquireInfo.reconsiderationAgency,".inquireInfo.reconsiderationAgency")
          if (data.inquireInfo.reconsiderationAgency) {
            console.log(111)
            Api.getEntrustingDepartList(data.inquireInfo.reconsiderationAgency.id).then((res) => {
              this.optionRespondentName = res.data.data
            })
          }
          this.inquireInfo = data.inquireInfo
          data.evidence.forEach((item) => {
            item.name = item.originName
            item.evidenceIdNo = item.id
            if (item.kindType === 1) {
              this.fileList1.push(item)
            } else if (item.kindType === 2) {
              this.fileList2.push(item)
            }
            this.evidenceIdList.push(item.id)
          })
          console.log(this.evidenceIdList)
        }
      })
    },
    // 增加一个申请人
    addApplicantInfo (type) {
      if (type === '1') {
        this.applicantInfo.fileListJpg = []
        const applicantInfo = { ...this.applicantInfo, id: uuid() }
        this.$nextTick(() => {
          this.$refs.refApplicant.addItem(applicantInfo)
        })
      } else {
        this.legalpersonInfo.fileListJpg = []
        const legalpersonInfo = { ...this.legalpersonInfo, id: uuid() }
        this.$nextTick(() => {
          this.$refs.refApplicant.addItem(legalpersonInfo)
        })
      }
    },
    // 文件上传
    // 上传文件之前的钩子
    beforeUpload (file) {
      const isLt100MB = file.size / 1024 / 1024 < 100
      const a = file.name
      const b = [
        '.txt',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.pdf',
        '.jpg',
        '.gif',
        '.png',
        '.bmp',
        '.wav',
        '.rar',
        '.wps',
        '.aiff',
        '.pcm',
        '.flac',
        '.alac',
        '.wma',
        '.mp3',
        '.ogg',
        '.aac'
      ]
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase())
      if (!isLt100MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$message({
          message: '上传文件大小不能超过 100MB!',
          type: 'warning',
          center: true
        })
        return false
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$message({
          message:
            '上传文件格式必须为1.txt 2.doc 3.docx 4.xls 5.xlsx 6.pdf 7.jpg 8.gif 9.png 10.bmp 11.wav 12.rar 13.wps',
          type: 'warning',
          center: true
        })
        return false
      }
    },
    // 限制文件上传个数
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 10 个文件，请删除部分文件后重新上传')
    },
    // 自定义上传
    handleUpload (param) {
      if (param.data.kindType === 1) {
        this.fileoneLoad = true
        ++this.rest1
      } else if (param.data.kindType === 2) {
        this.filetwoLoad = true
        ++this.rest2
      }
      const formData = new FormData()
      formData.append('caseOrderNo', this.caseOrderNo)
      formData.append('evidenceName', param.file.name)
      formData.append('evidence', param.file)
      formData.append('kindType', param.data.kindType) // 证据材料类型（0证件照1具体行政行为材料2其他补充材料）
      Api.uploadFile(formData)
        .then((data) => {
          param.file.evidenceId = data.data.data
          param.file.kindType = param.data.kindType
          if (param.data.kindType === 1) {
            this.fileList1.push(param.file)
            --this.rest1
          } else if (param.data.kindType === 2) {
            this.fileList2.push(param.file)
            --this.rest2
          }
          if (this.rest1 === 0) {
            this.fileoneLoad = false
          }
          if (this.rest2 === 0) {
            this.filetwoLoad = false
          }
        })
        .catch(() => {
          if (param.data.kindType === 1) {
            this.fileoneLoad = false
            this.rest1 = 0
            this.fileList1 = []
          } else if (param.data.kindType === 2) {
            this.filetwoLoad = false
            this.rest2 = 0
            this.fileList2 = []
          }
        })
    },
    // 删除文件
    handleRemove (file) {
      console.log(file)
      if (file.evidenceId) {
        Api.deleteFileById(file.evidenceId).then((res) => {
          if (file.kindType === 1) {
            this.fileList1.forEach((item, index) => {
              if (item.evidenceId === file.evidenceId) {
                this.fileList1.splice(index, 1)
              }
            })
          } else if (file.kindType === 2) {
            this.fileList2.forEach((item, index) => {
              if (item.evidenceId === file.evidenceId) {
                this.fileList2.splice(index, 1)
              }
            })
          }
        })
      } else if (file.evidenceIdNo) {
        if (file.kindType === 1) {
          this.fileList1.forEach((item, index) => {
            if (item.evidenceIdNo === file.evidenceIdNo) {
              this.fileList1.splice(index, 1)
            }
          })
        } else if (file.kindType === 2) {
          this.fileList2.forEach((item, index) => {
            if (item.evidenceIdNo === file.evidenceIdNo) {
              this.fileList2.splice(index, 1)
            }
          })
        }
        this.evidenceIdList.forEach((ite, ind) => {
          if (ite === file.evidenceIdNo) {
            this.evidenceIdList.splice(ind, 1)
          }
        })
      }
    },
    // 必填校验
    sureVale () {
      return new Promise((resolve) => {
        if (this.applicantInfoList.length === 0) {
          this.$message.error('至少添加一个申请人信息')
          return
        }
        if (!this.inquireInfo.reconsiderationAgency) {
          this.$message.error('请选择复议机关')
          return
        }
        if (this.respondentInfo.length === 0) {
          this.$message.error('请选择被申请人信息')
          return
        }
        if (!this.applyInfo.applyType) {
          this.$message.error('请输入行政复议请求')
          return
        }
        if (!this.factAndReason) {
          this.$message.error('请输入事实和理由')
          return
        }
        if (this.fileList1.length === 0) {
          this.$message.error('请上传具体行政行为证明材料')
          return
        }
        if (this.fileoneLoad || this.filetwoLoad) {
          this.$message.error('文件正在上传中')
          return
        }
        if (
          this.applicantInfoList.length !== 0 &&
          this.inquireInfo.reconsiderationAgency &&
          this.respondentInfo.length !== 0 &&
          this.applyInfo.applyType &&
          this.factAndReason &&
          this.fileList1.length !== 0 &&
          !this.fileoneLoad &&
          !this.filetwoLoad
        ) {
          resolve()
        }
      })
    },
    async compUsers () {
      // 校验所有申请人人口库
      const applicantInfoListCal = []
      if (this.applicantInfoList && this.applicantInfoList.length) {
        this.applicantInfoList.forEach((item) => {
          if (item.identificationType === '1001001') {
            if (item.applicantCategory === '1') {
              applicantInfoListCal.push({
                name: item.applicantName,
                id: item.identificationCard
              })
            } else if (item.applicantCategory === '2') {
              applicantInfoListCal.push({
                name: item.legalRepresentative,
                id: item.identificationCard
              })
            }
          }
        })
        const param = [...applicantInfoListCal]
        console.log(param, '437')
        const res = await this.checkUsers(param)
        return res
      }
    },
    async checkUsers (param) {
      if (!param || param.length <= 0) {
        return
      }
      let res = await Api.checkUsers(param)
      res = res?.data?.data
      console.log(res, '448')
      if (!res.code && res.result.length) {
        console.log('450')
        const str = res.result.join('、')
        return str
      } else {
        return ''
      }
    },
    // 提交申请
    async submit () {
      // const res = await this.compUsers()
      // if (res) {
      //   this.$message.warning(res)
      //   return false
      // }
      this.$refs.refApplicant.checkAll().then(() => {
        this.sureVale().then(() => {
          this.fullscreenLoading = true
          this.respondentInfo.forEach((ite) => {
            ite.departId = ite.id
          })
          const params = {
            applicantInfo: this.applicantInfoList,
            applyInfo: this.applyInfo,
            factAndReason: this.factAndReason,
            respondentInfo: this.respondentInfo,
            inquireInfo: this.inquireInfo,
            caseOrderNo: this.caseOrderNo,
            evidenceIdList: this.evidenceIdList,
            state: this.$route.query.state || null
          }
          console.log(11, params)
          if (this.isDetail) {
            Api.correctApplyInfo(params).then((res) => {
              this.fullscreenLoading = false
              if (res.data.code === '0') {
                this.$message({
                  message: '提交成功',
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.number = res.data.data
                    this.$router.replace({
                      name: 'oldDetailCase',
                      query: {
                        number: this.number
                      }
                    })
                  }
                })
              }
            }).catch(() => {
              this.fullscreenLoading = false
            })
          } else {
            Api.submitApplyInfo(params).then((res) => {
              this.fullscreenLoading = false
              console.log('提交res', res)
              if (res.data.code === '0') {
                this.$message({
                  message: '申请成功',
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.number = res.data.data
                    this.$router.replace({
                      name: 'oldDetailCase',
                      query: {
                        number: this.number
                      }
                    })
                  }
                })
              }
            }).catch(() => {
              this.fullscreenLoading = false
            })
          }
        })
          .catch((err) => {
            this.$message.error(err.message)
            return false
          })
      })
    },
    // 返回
    back () {
      console.log(this.$route.query.name)
      this.$router.push({
        name: this.$route.query.name,
        query: {
          number: this.number
        }
      })
    }
  }
}
